var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('iframe',{attrs:{"src":"https://backoffice.alorferi.com/privacy-policy/alorferi","width":"800","height":"500"}})])
}]

export { render, staticRenderFns }